import { TvmConnectButton, useTvmWalletService } from '@broxus/tvm-connect/lib';
import { observer } from 'mobx-react-lite';
// import { useTranslation } from 'react-i18next';

// import { DialogBadgeMinted } from '@/components/Dialogs/DialogBadgeMinted/DialogBadgeMinted';

import { PageLayout } from '@/components/PageLayout';
import { Profile } from '@/components/Profile';
import { ProfileConnectWallet } from '@/components/Profile/components';
import { ProfileConnectedWallet } from '@/components/Profile/components/ConnectedWallet/ConnectedWallet';
// import { Tabs } from '@/components/Tabs';
// import { badgeStoreTabs } from '@/constants/badges';
import { currencyImg } from '@/constants/wallet';
// import { useTabs } from '@/hooks';
import { useWallet } from '@/hooks/useWallet';
import { store } from '@/store';

// import { All as TabContent } from './components/Tabs';
import styles from './Mint.module.scss';

export const Mint = observer(() => {
  const walletService = useTvmWalletService();

  useWallet(walletService);
  // const { t } = useTranslation();
  const { user, nextLevel, xpBar } = store.profile;
  const { badgesCount } = store.badges;
  const { currencyName } = store.wallet;

  // const tabs = useTabs({
  //   initialTab: badgeStoreTabs.all,
  //   tabs: [
  //     { name: badgeStoreTabs.all, title: t('wallet.pages.mint.tabs.all') },
  //     {
  //       name: badgeStoreTabs.notMinted,
  //       title: 'Not minted', // t('wallet.pages.mint.tabs.common'),
  //     },
  //     {
  //       name: badgeStoreTabs.minted,
  //       title: 'Minted', // t('wallet.pages.mint.tabs.uncommon'),
  //     },
  //   ],
  // });

  // const badges = store.app.storeBadges(tabs.activeTab);

  return (
    <PageLayout className={styles.mint}>
      <Profile
        badges={badgesCount}
        user={user}
        nextLevel={nextLevel}
        xpBar={xpBar}
      >
        <TvmConnectButton
          popupType="drawer"
          standalone={false}
          trigger={({ connect }) =>
            walletService.isConnected ? (
              <ProfileConnectedWallet
                balance={walletService.balance}
                address={walletService.address?.toString() || ''}
                onClick={walletService.disconnect}
                currency={currencyName}
                icon={currencyImg}
              />
            ) : (
              <ProfileConnectWallet onClick={connect} />
            )
          }
        />
      </Profile>
      <section style={{ height: '70%' }} className="in-section in-col-center">
        {
          <div
            className="in-row in-row-center"
            style={{
              height: '7rem',
              marginTop: '-7rem',
              alignItems: 'stretch',
            }}
          >
            <TvmConnectButton
              popupType="drawer"
              standalone={false}
              trigger={({ connect }) =>
                walletService.isConnected ? (
                  <ProfileConnectedWallet
                    balance={walletService.balance}
                    address={walletService.address?.toString() || ''}
                    onClick={walletService.disconnect}
                    currency={currencyName}
                    icon={currencyImg}
                    className={styles.wallet}
                  />
                ) : (
                  <ProfileConnectWallet
                    onClick={connect}
                    className={styles.wallet}
                  />
                )
              }
            />
          </div>
        }
      </section>
      {/* <section className="in-section">
        <Tabs {...tabs} />
        <TabContent
          onBadgeClick={() => setDialogBadgeMinted(!dialogBadgeMinted)}
          badges={badges}
        />
      </section>
      <DialogBadgeMinted
        isOpen={dialogBadgeMinted}
        onAction={() => setDialogBadgeMinted(false)}
        onClose={() => setDialogBadgeMinted(false)}
      /> */}
    </PageLayout>
  );
});

export default Mint;
